import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import BackButton from '../../../components/shared/BackButton';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AttendanceDeclarationViewModel from './viewModel';
import DownloadItem from './DownloadItem';
import {
  PageContainer,
  PageHeader,
  DeclarationList,
  EmptyStateText,
  Subtitle,
  DisclaimerBox,
  DisclaimerText,
  WhatsAppRow
} from './styled';
import Button from '@mui/material/Button';

export default function AttendanceDeclarationPage() {
  const navigate = useNavigate();
  const { isLoading, schedules } = AttendanceDeclarationViewModel();

  return (
    <PageContainer>
      <PageHeader>
        <BackButton onClick={() => navigate('/meus-arquivos')} />
        <Typography variant="h3">Declaração de comparecimento</Typography>
      </PageHeader>

      <Subtitle>Segue a lista de atendimentos com presença confirmada para download:</Subtitle>

      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress sx={{ color: 'brand.darkGreen' }} />
        </Box>
      ) : schedules.length === 0 ? (
        <EmptyStateText>Aguarde a médica confirmar sua presença nos atendimentos.</EmptyStateText>
      ) : (
        <DeclarationList>
          {schedules.map(schedule => (
            <DownloadItem key={schedule.id} schedule={schedule} />
          ))}
        </DeclarationList>
      )}

      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <DisclaimerBox>
          <DisclaimerText>
            A lista disponibiliza apenas os 5 últimos atendimentos cuja presença foi confirmada pela médica. Precisando de
            ajuda, fale conosco:
          </DisclaimerText>
        </DisclaimerBox>
      </Box>
      <WhatsAppRow>
        <Button
          variant="inline"
          color="primary"
          href={process.env.REACT_APP_WHATSAPP}
          target="_blank"
          component="a"
          endIcon={<WhatsAppIcon />}
        >
          Falar com Equipe de Cuidados
        </Button>
      </WhatsAppRow>
    </PageContainer>
  );
}
